// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__37Uz7","footer":"ModalUpdate_footer__3xbyK"};